<template>
  <div>
    <el-dialog title="添加子设备" :visible.sync="dialogFormVisible" :append-to-body="true" class="imgbox" width="30%" :before-close="resetForm" :close-on-click-modal='false'>
      <el-form :model="form" ref="ruleForm" :rules="rules" label-width="90px" label-position="top">
        <el-form-item label="产品" prop="productKey">
          <el-select v-model="form.productKey" style="width:100%" :clearable="true" >
            <el-option
            v-for="item in options"
            :key="item.productId"
            :label="item.productName"
            :value="item.productKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备" prop="subDeviceDesc">
          <!-- <el-select
          filterable
          class="sel"
          ref="deviceScope"
          style="width:100%"
          placeholder="请选择设备"
          v-model="form.subDeviceDesc"
          :disabled="form.productKey === ''"
          @focus="focusStatus&&openDrawer()"
          :multiple="true">
            <el-option
              v-for="item in charactorOptions"
              :key="item.deviceName"
              :label="item.deviceName"
              :value="item.deviceName">
            </el-option>
          </el-select> -->
          <el-input
          ref="deviceScope"
          autocomplete="off"
          placeholder="请选择设备"
          suffix-icon="el-icon-arrow-down"
          v-model="form.subDeviceDesc"
          :disabled="form.productKey === ''"
          @focus="focusStatus&&openDrawer()"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="submit('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
     <Drawer
    v-if="drawerFlag"
    :accessData="toSonData"
    :drawerFlag="drawerFlag"
    :productKey="form.productKey"
    @closeDrawer="closeDrawer"
    @getData="receive"/>
  </div>
</template>
<script>
import { subDeviceIdProductList, addSubDevice } from '@/api/deviceManagement'
import Drawer from './addSonDrawer'
export default {
  components: {
    Drawer
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    productKey: {
      type: String,
      default: ''
    },
    deviceName: {
      type: String,
      default: ''
    }
  },
  data () {
    var validateField = (rule, value, callback) => {
      if (this.charactorOptions.length < 1) {
        callback(new Error('请选择设备'))
      } else {
        callback()
      }
    }
    return {
      form: {
        productKey: '',
        subDeviceDesc: ''
      },
      rules: {
        productKey: [
          { required: true, message: '请选择产品', trigger: 'change' }
        ],
        subDeviceDesc: [
          { validator: validateField, trigger: 'change' }
        ]
      },
      options: [],
      charactorOptions: [], // 接收drawer回传的值
      toSonData: [],
      focusStatus: true,
      drawerFlag: false
    }
  },
  created () {
    this.init()
  },
  watch: {
    // charactorOptions: {
    //   handler (val) {
    //     console.log(val, '我改变了')
    //   }
    // },
    // toSonData: {
    //   handler (val) {
    //     console.log(val, '我改变了')
    //   }
    // }
  },
  methods: {
    changer (val) {
      console.log(val)
    },
    submit () {
      this.$refs.ruleForm.validate((valid) => {
        console.log(this.form, this.charactorOptions)
        if (valid) {
          // console.log(11)
          const params = {}
          params.parentProductKey = this.productKey
          params.parentDeviceName = this.deviceName
          console.log(params)
          params.subDeviceAddList = this.charactorOptions
          addSubDevice(params).then(res => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '创建成功'
              })
              this.$emit('closeDialog', 1)
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.$emit('closeDialog')
    },
    init () {
      subDeviceIdProductList({}).then((res) => {
        console.log(res.data.data)
        this.options = res.data.data
      })
    },
    // 打开抽屉
    openDrawer () {
      this.drawerFlag = true
      this.$refs.deviceScope.blur()
      this.focusStatus = false
      this.toSonData = JSON.parse(JSON.stringify(this.charactorOptions))
    },
    // 关闭抽屉
    closeDrawer () {
      this.drawerFlag = false
      this.focusStatus = true
    },
    // 获取子组件数据
    receive (val) {
      console.log('子组件数据', val)
      this.charactorOptions = val
      // this.form.accessIds = val.map(res => res.buttonId)
      val.length > 0 ? this.form.subDeviceDesc = `已选择个${val.length}设备` : this.form.subDeviceDesc = ''
      this.drawerFlag = false
      this.focusStatus = true
    }
  }
}
</script>

<style lang='less' scoped>
  .el-form-item{
    margin: 0;
  }
  /deep/ .el-form--label-top .el-form-item__label{
    padding: 0;
  }
</style>
